import { Component, OnInit, ViewChild } from '@angular/core';
import { Speaker } from 'src/app/entity/Speaker';
import { ComposeMailComponent } from '../../email/include/compose-mail/compose-mail.component';
import { MailsService } from 'src/app/service/mails.service';
import { SpeakerService } from 'src/app/service/speaker.service';
import { Contact } from 'src/app/entity/Contact';
import { Observable } from 'rxjs';
import { Titre, Pays } from 'src/app/entity/prospect';
import { TitreService } from 'src/app/service/titre.service';
import { ProspectService } from 'src/app/service/prospect.service';
import {ConfirmationService} from 'primeng/api';
import { Mails } from 'src/app/entity/Mails';
@Component({
  selector: 'app-speaker',
  templateUrl: './speaker.component.html',
  styleUrls: ['./speaker.component.css']
})
export class SpeakerComponent implements OnInit {
  cols: { field: string; header: string; }[];
  loading: boolean;
  speakers: Speaker[];
  selectedSpeakers: Speaker[];
  selectedSpeaker: Speaker;
  exportColumns: { title: string; dataKey: string; }[];
  loadByOrder: boolean;

  uploadedFiles: any[];
  @ViewChild(ComposeMailComponent )
  private composeMailComponent: ComposeMailComponent;
  loaded: number;
  visible: boolean;
  payss: Observable<Pays[]>;
  positions: Titre[]
  positionsS: string[];
  constructor(private speakerService: SpeakerService, private mailsService: MailsService 
    ,private titreService: TitreService,private prospectService: ProspectService,private confirmationService: ConfirmationService) {


  }

  ngOnInit() {


    this.cols = [

      { field: 'nom', header: 'Name' },
      { field: 'position', header: 'Position' },
      { field: 'entreprise', header: 'Company' },
      { field: 'mail', header: 'Email' },
      { field: 'mobile', header: 'Mobile' },

      { field: 'description', header: 'Panel' },
      { field: 'pays', header: 'Country' },
      { field: 'note', header: 'Note' },
      { field: 'status', header: 'Status' }
    ];



    let colsExport = [

      { field: 'nom', header: 'Name' },
      { field: 'position', header: 'Position' },
      { field: 'entreprise', header: 'Company' },

      { field: 'pays', header: 'Country' }
    ];
    this.exportColumns = colsExport.map(col => ({ title: col.header, dataKey: col.field }));
    this.loadAll();
    //this.sychronier();
  }

  loadAll() {
    //console.log("this.loadByOrder " + this.loadByOrder);

    if (!this.loadByOrder)
      this.speakerService.getAllSpeakerEntities('speaker').subscribe(result => {

        this.speakers = result;
      })
    else
      this.speakerService.orederBySpeaker().subscribe(result => {

        this.speakers = result;
      })

  }
  columns: any[];
  exportPdf() {
    /*
    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        // @ts-ignore
        const doc = new jsPDF.default(0, 0);
        // @ts-ignore
        doc.autoTable(this.exportColumns, this.speakers);
        doc.save('speakerNAPEC2020.pdf');
      })
    })
    */
  }

  filterPositions(filter: string) {
    if (filter && filter.length > 0)
      this.titreService.getAllDesignation(filter).subscribe(result => {
        this.positions = result;
        this.positionsS = []

        this.positions.forEach(element => {
          this.positionsS.push(element.designation)
        });
      });
  }

  filterPays(val: string): void {






    if (val && val.length > 0)
      this.payss = this.prospectService.findPaysByDesignation(val);




  }


  exportExcel() {
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(this.speakers);
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "primengTable");
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    });
  }

  blur(row: Speaker) {
    this.selectedSpeaker = row;
    this.save();
  }


  save() {
    if (this.selectedSpeaker && this.selectedSpeaker.idSpeaker) {


      this.speakerService.updateSpeaker(this.selectedSpeaker).subscribe(result => {

        this.loadAll();
        this.visible=false;
      })
    }
  }
  create() {
    if (this.selectedSpeaker  ) {

      this.selectedSpeaker.type="speaker"
      this.speakerService.addSpeaker(this.selectedSpeaker).subscribe(result => {

        this.loadAll();
        this.visible=false;
      })
    }
  }
  delete(speaker:Speaker){
    this.speakerService.deleteSpeaker(speaker).subscribe(
      result=>{
        this.loadAll();
      }
    )
  }
  prepareCreate() {
    this.selectedSpeaker = new Speaker();
    this.visible=true;
  }
 
  editNote(row: Speaker) {
    if (row && row.idSpeaker) {


      this.speakerService.updateSpeaker(row).subscribe(result => {


      })
    }
  }

  printBadge() {
    this.speakerService.print(this.selectedSpeaker).subscribe(
      (res: any) => {

        var filename = 'restfile.pdf';

        filename = filename.replace(/[/\\?%*:|"<>]/g, '-');
        var fileURL = URL.createObjectURL(res);
        window.open(fileURL);

      }


    )
  }

  status(stausSent: string) {
    this.selectedSpeaker.status = stausSent;
    this.speakerService.updateSpeaker(this.selectedSpeaker).subscribe(result => {
      this.loadAll()
    })
  }


  sendLinkEBAdge(nbr: number ) {


    this.uploadedFiles = []
    let contact = new Contact();
this.selectedSpeakers.forEach(element => {
  if(element.mail){
    if(contact.mail)
    contact.mail = contact.mail+';'+ element.mail;
    else
    contact.mail =  element.mail;
  }

});



    this.mailsService.findodel(nbr).subscribe(model => {
     // let idEncrypt =speaker.idClient * 4560;


      //model.corp = model.corp.replace("@link@", 'https://badgesnapec.firebaseapp.com/badges/badgesclient' + idEncrypt)
  
  
      this.composeMailComponent.prepareEmailModel(model, contact, null, null, [])

      
    })




  }
  sendEBAdge(nbr: number) {


    this.uploadedFiles = []
    this.speakerService.print(this.selectedSpeaker).subscribe(
      (res) => {
        var filename = this.selectedSpeaker.nom + 'badge.pdf';

        filename = filename.replace(/[/\\?%*:|"<>]/g, '');
        res.name = filename;
        this.uploadedFiles.push(res);


        this.mailsService.findodel(nbr).subscribe(result => {

          // this.composeMailComponent.prepareEmailModelSpeaker(result, this.selectedSpeaker, this.uploadedFiles)
        })

      }
    );

  }

  gotoBadges(id: number) {

    let idEncrypt = id * 4560;


    window.open('https://badgesnapec.firebaseapp.com/badges/badgesclient' + idEncrypt, '_blank');


  }

  /*
    sychronier() {
      //console.log("importation");
  
      let a = this.diverBadgeService.getAllBadgesNotImported().subscribe(result => {
        //console.log("importation  11111" + JSON.stringify(result));
        a.unsubscribe();
        if (result) {
          let nbr = result.length;
          let loadedloca = nbr;
          //console.log("nbrrr " + nbr);
  
  
          result.forEach(badge => {
  
  
            let speaker = this.speakerService.copyFromBadg(badge);
            this.speakerService.addSpeaker(speaker).subscribe(result => {
              nbr--;
              badge.imported = true;
              this.diverBadgeService.updateBadge(badge.id, badge)
              //console.log("nbrrr0d " + nbr);
  
              if (nbr == 0) {
                this.loadAll();
                this.loaded = loadedloca;
              }
  
            })
  
          });
        }
  
      })
  
    }
  */



 sendmail(id:number){
 
      this.sendLinkEBAdge(id );
 
}/*
sendmail(id:number){
  if(this.selectedSpeakers){
    this.selectedSpeakers.forEach(element => {
      this.sendLinkEBAdge(id,element);
    });
  }
}*/

 confirm1(speaker:Speaker) {
   //console.log("confirm "+speaker.nom);
   this.delete(speaker);/*
  this.confirmationService.confirm({
      message: 'Are you sure that you want to proceed?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
 this.delete(speaker);
      },
      reject: () => {
    
      }
  });*/
}
sendEmail(to: string,corp:string,objet:string) {

  let mail =new Mails();
 mail.tto = to;
 
mail.corp=corp;
mail.objet=objet;


  var fd = new FormData();

  for (let file of this.uploadedFiles) {

    fd.append("file", file, file.name);

  }

  this.mailsService.editDraft(mail).subscribe(result => {

    mail = result;
    fd.append("mail", JSON.stringify(mail));



    this.mailsService.upload(fd).subscribe(result => {
      let resSTR = JSON.stringify(result);
      let resJSON = JSON.parse(resSTR);
     
      if (resJSON._body.includes("Sent")) {
       
      }


      window.alert(resJSON._body);

    }
      , error => {

    
        window.alert(error);

      }
    )
  });
 
}
 
}




